var React = require('react');

function LineChart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M38.3332 10L22.4998 25.8333L14.1665 17.5L1.6665 30","stroke":"#01C716","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

LineChart.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = LineChart;

LineChart.default = LineChart;
